import { AnyAction } from 'redux';
import { RESET_STATE, GET_ALL_SYNC, SET_SYNC_COUNT, GET_SYNC_AGENT, GET_SYNC_AGENT_ATTRIBUTE_MAP, GET_SYNC_AGENT_OU_NODE } from '@app/store/constants';

const initialState = {
    syncAgent: {},
    syncAgentAttributeMap: {},
    syncAgentOUNode: {},
    syncs: [],
    count: 0,
};

export function syncs(state = initialState, action: AnyAction) {
    const { payload, type } = action;

    switch (type) {
        case RESET_STATE:
            return initialState;

        case GET_ALL_SYNC:
            return {
                ...state,
                syncs: payload
            };

        case SET_SYNC_COUNT:
            return {
                ...state,
                count: payload
            };

        case GET_SYNC_AGENT:
            return {
                ...state,
                syncAgent: payload
            };

        case GET_SYNC_AGENT_ATTRIBUTE_MAP:
            return {
                ...state,
                syncAgentAttributeMap: payload
            };

        case GET_SYNC_AGENT_OU_NODE:
            return {
                ...state,
                syncAgentOUNode: payload
            };

        default:
            return state;
    }
}
